class h {
  constructor() {
    this.eventMap = /* @__PURE__ */ new Map();
  }
  /**
   * Registers the callback for a given event
   */
  on(t, e) {
    const n = typeof e;
    if (n !== "function")
      throw new Error(`Callback should be a function, ${n} given.`);
    const r = Array.isArray(t) ? new Set(t) : /* @__PURE__ */ new Set([t]), i = Array.from(r);
    for (let s = 0; s < i.length; s += 1) {
      const o = i[s], a = this.eventMap.get(o);
      if (Array.isArray(a)) {
        a.push(e);
        continue;
      }
      this.eventMap.set(o, [e]);
    }
    return this;
  }
  /**
   * Unregister the callbacks for a given event
   */
  off(t, e) {
    const n = Array.isArray(t) ? new Set(t) : /* @__PURE__ */ new Set([t]), r = Array.from(n);
    for (let i = 0; i < r.length; i += 1) {
      const s = r[i];
      if (e !== void 0) {
        const o = this.eventMap.get(s);
        if (!o) continue;
        this.eventMap.set(
          s,
          o.filter((a) => a !== e)
        );
        continue;
      }
      this.eventMap.delete(s);
    }
    return this;
  }
  /**
   * Dispatches all callbacks for a given event
   */
  dispatch(t, ...e) {
    const n = this.eventMap.get(t);
    if (n === void 0)
      return this;
    for (let r = 0; r < n.length; r += 1)
      n[r](...e);
    return this;
  }
}
export {
  h as EventDispatcher
};
//# sourceMappingURL=eventDispatcher.js.map
